enum FeatureKey {
  'SECRET' = 'SECRET',
  'BRAZE_SANDBOX' = 'BRAZE_SANDBOX',
  'CONTENTFUL_BLOG' = 'CONTENTFUL_BLOG',
  'LOGIN_WITH_CODE' = 'LOGIN_WITH_CODE',
}

export type FeatureKeyString = keyof typeof FeatureKey

export interface Feature {
  key: FeatureKeyString
  title: string
  description: string
  isEmployee: boolean
  keepEnabledAfterLogout: boolean
}

export const features: Feature[] = [
  {
    key: FeatureKey.SECRET,
    title: 'Secret feature',
    description: "You'll find out.. 😏",
    isEmployee: true,
    keepEnabledAfterLogout: false,
  },
  {
    key: FeatureKey.BRAZE_SANDBOX,
    title: 'Braze Sandbox',
    description: 'Enable to see and test the campaigns from the sandbox account',
    isEmployee: true,
    keepEnabledAfterLogout: false,
  },
  {
    key: FeatureKey.CONTENTFUL_BLOG,
    title: 'Enable Blogs from Contentful',
    description: 'Enable to get blogs from Contentful',
    isEmployee: true,
    keepEnabledAfterLogout: true,
  },
  {
    key: FeatureKey.LOGIN_WITH_CODE,
    title: 'Login with code',
    description: 'Login with a code instead of using a magic link',
    isEmployee: false,
    keepEnabledAfterLogout: true,
  },
]
